import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form } from 'react-bootstrap-5';

import { setFilterAttribute } from '../../../store/actions/criteria';

function SingleCheck({ criteria, attribute, label, reverse = false, setFilterAttribute, type = 'checkbox' }) {
  return (
    <Form.Check
      checked={criteria[attribute]}
      id={`${attribute}_check`}
      label={label}
      reverse={reverse}
      type={type}
      onChange={e => setFilterAttribute(attribute, e.target.checked)}
    />
  );
}

SingleCheck.propTypes = {
  attribute: PropTypes.string.isRequired,
  criteria: PropTypes.object.isRequired,
  label: PropTypes.string,
  reverse: PropTypes.bool,
  setFilterAttribute: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['radio', 'checkbox', 'switch']),
};

const mapStateToProps = ({ criteria }) => ({ criteria });

export default connect(mapStateToProps, { setFilterAttribute })(SingleCheck);
